import React from 'react';
import Hop from './Components/Hop'
import 'bulma/css/bulma.css'
import Footer from './Components/Footer/Footer';
function App() {return(
    <div>
        <Hop />
        <Footer />
    </div>
)  }

export default App;
